import React from 'react';
import { makeRequest, navigate, url } from "js/services/Network";
import { Section } from 'js/new/Components';
import App from 'js/new/Layouts/AppLayout';
import AppState from 'js/stores/AppState';
import AppUser from 'js/stores/AppUser';
import AnonymousId from 'js/services/AnonymousId';
import { AppButton } from 'js/new/Components/App';

export default function Referral() {
  const [referral, setReferral] = React.useState();
  const [singleUseToken, setSingleUseToken] = React.useState();
  const defaultRefName = "A friend";

  const redirect = (link, props, params) => navigate(url(link, props, params));

  const steps = [
    "Sign up with either your socials or your credentials.",
    "Get ₦500 on sign up which can be used at anytime.",
    "Get a referral link and share with your friends to earn ₦3,000 more."
  ];

  React.useEffect(() => {
    const pageEvent = async () => {
      if (AppUser.isLoggedIn) {
        redirect('referral-complete');
        return;
      }

      const urlParts = window.location.href.split('/');
      const alias = urlParts[urlParts.length - 1];

      try {
        const response = await makeRequest('referrer-data', null, { alias, anonymous_id: AnonymousId });
        if (response.data?.message === 'Success') {
          setReferral(response.data?.data);
          setSingleUseToken(response.data.anonymous_id);
        }
      } catch (error) {
      }
    };

    pageEvent();
  }, [AppUser.isLoggedIn]);

  return (
    <App>
      <Section>
        <div className="tw-space-y-4 md:tw-space-y-8">
          <h1 className='tw-text-center'>Unlock Rewards with <span className="tw-text-secondary">POD</span></h1>
          <p className='tw-text-center'>
            {referral ? (referral.first_name ?? referral.referrer_alias) : defaultRefName} invited you to join PayOnDelivery!
            Sign up now to get ₦3,500 delivery bonus and ₦500 on your first transaction.
          </p>

          <div className='tw-text-center'>
          <AppButton
            title={'Sign Up Now'}
            className={'tw-w-full md:tw-max-w-lg'}
            onClick={() => AppState.showLoginSignup('signup', `${singleUseToken}`)}
          />
          </div>

          <div className='tw-bg-tertiary tw-rounded-3xl tw-space-y-4 md:tw-space-y-8 tw-p-8'>
            <h2 className='md:tw-text-center'>How it works</h2>

            <div className='tw-grid md:tw-grid-cols-3 tw-gap-8'>
              {steps.map((step, i) => (
                <div key={i} className="tw-flex tw-gap-2 md:tw-flex-col tw-items-center md:tw-items-start">
                  <div className='tw-flex tw-justify-center tw-items-center tw-rounded-full tw-bg-primary text-white from35-50'>
                    {i + 1}
                  </div>
                  <p>{step}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Section>
    </App>
  );
}
